import { forwardRef, useMemo } from 'react';
import { toDisplayDateFormat } from 'lib/utils/date';
import InputWithIcon from '../../InputWithIcon';

const DateDisplay = ({ value, ...rest }, ref) => {
  const displayValue = useMemo(() => toDisplayDateFormat(value), [value]);
  return <InputWithIcon {...rest} readOnly ref={ref} value={displayValue} iconName="calendar" />;
};

export default forwardRef(DateDisplay);
